import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../common/components/Dialog';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import MarkAsCancelledForm from './MarkAsCancelledForm';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import { withTranslation } from 'react-i18next';

class MarkAsCancelledDialog extends Component {
	dialogConfig() {
		const { onCancel } = this.props;

		return {
			header: this.title(),
			body: this.renderBody(),
			onHide: onCancel,
			footer: this.renderFooter()
		};
	}

	// a running subscription is ended from its panel as "End subscription now"
	title() {
		const { subscription, t } = this.props;
		return t(subscription ? 'PaymentHistory_Subscription_EndNow' : 'PaymentHistory_MarkAsCancelled');
	}

	renderBody() {
		const { onConfirm, outstandingTotal, paymentMethod, showWarning, subscription, removesFrom } = this.props;
		const initialValues = { outstandingTotal: outstandingTotal, refundedAmount: 0 };
		if (subscription && subscription.lastDay) {
			// a requested cancellation: end it after the last day the parent was given, or today if that's passed
			initialValues.cancellationDate = moment.max(moment().startOf('day'), moment(subscription.lastDay).add(1, 'day')).toDate();
		}

		return <MarkAsCancelledForm onSubmit={onConfirm} initialValues={initialValues}
			paymentMethod={paymentMethod} showWarning={showWarning} endsSubscription={!!subscription} removesFrom={removesFrom} />;
	}

	renderFooter() {
		const { onCancel, t } = this.props;

		const closeBtn = <Button key='close' onClick={onCancel}>{t('Common_Close')}</Button>;
		const confirmBtn = <RemoteSubmitButton key='save' style='primary' formName='markAsCancelled' label={this.title()} />;
		return [closeBtn, confirmBtn];
	}

	render() {
		const { show, block, unblock } = this.props;
		const dialogConfig = this.dialogConfig();
		return <Dialog config={dialogConfig} show={show} block={block} unblock={unblock} />;
	}
}

MarkAsCancelledDialog.propTypes = {
	show: PropTypes.bool,
	block: PropTypes.oneOfType([
		PropTypes.instanceOf(RegExp),
		PropTypes.string,
		PropTypes.array,
		PropTypes.func
	]),
	unblock: PropTypes.oneOfType([
		PropTypes.instanceOf(RegExp),
		PropTypes.string,
		PropTypes.array,
		PropTypes.func
	]),
	onCancel: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
	// the running subscription the payment belongs to, if any
	subscription: PropTypes.object,
	// what the date removes from (lessons or sessions) - only paid instalment payments, the others lose all of them whatever the date
	removesFrom: PropTypes.oneOf(['lessons', 'sessions'])
};

export default withTranslation()(MarkAsCancelledDialog);